import React from 'react';

import useStorePriceDisplayConditions from '../../../hooks/usePriceDisplayConditions';
import {OrderLine} from '../../../transport/apiServiceResponse';
import {OrderLineSticker} from '../../../transport/apiServiceResponse';
import {renderSticker} from '../../../utils/functions';
import {renderStickerSmall} from '../../../utils/functions';
import {getProductDisplayRules} from '../../../utils/rewards';
const OrderLineItemStickers = ({
  item,
  size,
  isProductScreen = false,
}: {
  item: OrderLine;
  size: 'small' | 'large';
  isProductScreen?: boolean;
}) => {
  const {showMemberPrice} = useStorePriceDisplayConditions();
  const {presentAsPublicMemberProduct, presentAsPrivateMemberProduct} = getProductDisplayRules(item);
  const stickers = item?.stickers;

  if (!stickers || stickers.length === 0) {
    console.warn('No stickers found for item', item);
    return <></>;
  }

  const result = stickers.map((sticker: OrderLineSticker) => {
    if (
      (sticker.sticker_type === 'private_loyalty_member' &&
        !(showMemberPrice.privatePricing && presentAsPrivateMemberProduct)
      ) ||
      (sticker.sticker_type === 'public_loyalty_member' &&
        !(showMemberPrice.publicPricing && presentAsPublicMemberProduct)
      )
    ) {
      return null;
    }

    if (size === 'small') {
      return renderStickerSmall(sticker);
    } else if (size === 'large') {
      return renderSticker(sticker, isProductScreen);
    } else {
      console.error('Invalid size', size);
      return null;
    }
  });

  return <>{result}</>;
};

export default OrderLineItemStickers;
